module.exports = __webpack_public_path__ + "static/icone-etiqueta-preco-d3a4e38b3ea3b7aa44f618a264951dfc.svg";